import { ITimezone } from 'features/user';

import { UserInfo } from '../store/types';

export const convertUsersToTable = (timezone: ITimezone, users: UserInfo[]) => users.map((user) => ({
  ...user,
  key: user.id,
  created: timezone.commaFormat(user.created),
  role: user.role,
}));
